// GA4 custom event tracking utility
// Uses the existing gtag.js snippet already installed in index.html

export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, {
      page_location: window.location.href,
      page_title: document.title,
      ...params,
    });
  }
};

// Predefined events
export const trackBuyDeck = (location) => {
  trackEvent('click_buy_deck_' + location, { button_location: location });
};

export const trackGuidedWorkshop = (location) => {
  trackEvent('click_guided_workshop_' + location, { button_location: location });
};

export const trackWorkshopFormSubmit = () => {
  trackEvent('submit_workshop_form', { button_location: 'workshop_form' });
};
